import React, { useState } from "react";
import OutsideClickHandler from "react-outside-click-handler";
import { makeStyles } from "@material-ui/core/styles";
import MoreHorizIcon from "@material-ui/icons/MoreHoriz";
import CloudDownloadOutlinedIcon from "@material-ui/icons/CloudDownloadOutlined";
import {FileIcon} from "../../../../../ui/FileIcon";

const useStyles = makeStyles(() => ({
    card: {
        position: "relative",
        height: 150,
        width: 150,
        background: "#FFFFFF",
        border: "1px solid #CACCD1",
        boxSizing: "border-box",
        boxShadow:
            "0px 1px 1px rgba(0, 0, 0, 0.2), 0px 2px 1px rgba(0, 0, 0, 0.2)",
        borderRadius: "5px"
    },
    docIcon: {
        position: "absolute",
        left: "10px",
        top: "18px"
    },
    docName: {
        position: "absolute",
        left: "6.67%",
        right: "6.67%",
        top: "70%",
        bottom: "19.33%",
        fontSize: "10px",
        color: "#304967"
    },
    moreIcon: props => ({
        position: "absolute",
        left: "79.11%",
        right: "7.56%",
        top: "8.67%",
        bottom: "88.26%",
        color: props.isOpened ? "#FFFFFF" : "#C4C4C4",
        zIndex: 100
    }),
    downloadIcon: {
        cursor: "pointer",
        position: "absolute",
        left: "79.11%",
        right: "7.56%",
        top: "30.67%",
        bottom: "88.26%",
        zIndex: 98,
        "& > svg":{
          color: "#C4C4C4",
        }
    },
    docPopover: props => ({
        display: props.isOpened ? "block" : "none",
        position: "absolute",
        left: "40%",
        right: "0%",
        top: "0%",
        bottom: "0%",
        background: "rgba(89, 110, 121, 0.8)",
        borderRadius: "0px 5px 5px 0px",
        zIndex: 99
    }),
    delete: {
        position: "absolute",
        right: "0%",
        top: "30%",
        background: "rgba(255, 255, 255, 0)",
        color: "#FFFFFF",
        padding: "8px 16px",
        "&:hover": {
            background: "rgba(255, 255, 255, 0.2)"
        }
    }
}));

const DocumentPreview = ({ file, onItemDelete, editmode }) => {
    const [isOpened, open] = useState(false);
    const classes = useStyles({ isOpened });
    let link = '/work/api/file/' + file.id;

    return (
        <div className={classes.card} key={file.id}>
            <div className={classes.docIcon}>
              <FileIcon mimeType={file.mimeType} />
            </div>
            <div className={classes.docName}>{file.fileName}</div>
            {editmode && <>
            <MoreHorizIcon
                className={classes.moreIcon}
                onClick={() => open(true)}
            />
            <OutsideClickHandler onOutsideClick={() => open(false)}>
                <div className={classes.docPopover}>
                    <div
                        className={classes.delete}
                        onClick={() => {
                            open(false);
                            onItemDelete(file.id);
                        }}
                    >
                        Удалить
                    </div>
                </div>
            </OutsideClickHandler></>
          }
          <a title="Скачать" href={link} download={file.fileName} className={classes.downloadIcon}>
            <CloudDownloadOutlinedIcon/>
          </a>
        </div>
    );
};

export default DocumentPreview;
